import { Button, Card, DynamicLink, Flex } from "@capioweb/ui-components/src"
import { QBankImage } from "../../@types/CapioWeb/core"
import ContentLink from "../../@types/EpiFoundationSpa/Models/ContentLink"
import {
	LinkProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { imageUrlToImageProps } from "../../utils"
import { BlockCommonLayout } from "../../utils/layout"

interface NewsPageCardProps {
	heading: StringProperty
	preamble: StringProperty
	imageDesktopBlock: QBankImage
	contentLink: ContentLink
	publishingDate: StringProperty
	imagePosition: StringProperty
}

interface CapioNewsListingBlockProps {
	header: StringProperty
	ctaLink: LinkProperty
	newsPages: NewsPageCardProps[]
}

const NewsPageCard: React.FC<NewsPageCardProps> = (props) => {
	const srcSetSizes = [
		{ width: 750, breakpoint: 768 },
		{ width: 1000, breakpoint: 2560 },
	]
	return (
		<Card
			w="100%"
			h={48.5}
			media={
				<>
					{props?.imageDesktopBlock?.media?.value && (
						<img
							{...imageUrlToImageProps(
								props?.imageDesktopBlock?.media?.value?.url,
								"",
								props?.imageDesktopBlock?.alternateText?.value,
								true,
								true,
								srcSetSizes
							)}
							style={
								props.imagePosition?.value === "center top"
									? { objectPosition: "center top" }
									: null
							}
						/>
					)}
				</>
			}
			borderColor="blue33"
		>
			<Card.DateLine>{props?.publishingDate.value ?? ""}</Card.DateLine>
			<Card.TitleNews>{props?.heading.value ?? ""}</Card.TitleNews>
			<Card.Preamble>{props?.preamble.value ?? ""}</Card.Preamble>
		</Card>
	)
}

const CapioNewsListingBlock: React.FC<CapioNewsListingBlockProps> = ({
	newsPages,
	header,
	ctaLink: cta,
	...rest
}) => {
	return (
		newsPages?.length > 0 && (
			<BlockCommonLayout {...rest} heading={header}>
				<Flex
					w={1}
					flexWrap="wrap"
					justifyContent="space-between"
					alignContent="space-between"
					columnGap={{ m: 3 }}
					rowGap={{ _: 2, m: 3 }}
					mb={{ _: 2, m: 3 }}
				>
					{newsPages.map((c, i) => (
						<Flex
							key={`newsPage${i}`}
							w={1}
							flexShrink={1}
							flexGrow={1}
							flexBasis={{
								_: "100%",
								m: i === 0 ? "calc(100%)" : "calc(50% - 24px)",
								l:
									i === 0
										? "calc(100% / 3 * 2 - 12px)"
										: "calc(100% / 3 - 24px)",
							}}
							px={0}
						>
							{c?.contentLink?.url && (
								<DynamicLink url={c.contentLink.url ?? "#"}>
									<NewsPageCard {...c} />
								</DynamicLink>
							)}
						</Flex>
					))}
				</Flex>

				{cta?.href && (
					<Button.Link
						variant="ghost"
						to={cta?.href ?? "#"}
						target={cta?.target}
					>
						{cta?.text ?? ""}
					</Button.Link>
				)}
			</BlockCommonLayout>
		)
	)
}

export { CapioNewsListingBlock }
